var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CSidebar',{attrs:{"minimize":_vm.minimize,"unfoldable":"","fixed":false,"show":_vm.show,"colorScheme":"light"},on:{"update:show":(value) => _vm.$store.commit('sidebar.set', ['sidebar_show', value])}},[_c('CRenderFunction',{attrs:{"flat":"","contentToRender":_vm.navStructure}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }